import React from 'react';
import Head from './Head';
import { IComponentSlideHead } from '../../component';
import { inject, observer } from 'mobx-react';
import RootStore from '../../store/RootStore';

const AllForXHead = (props: IComponentSlideHead) => {
  let { pagedataStore } = props.rootStore;
  return <Head {...props} {...pagedataStore.getViewDetail()} />;
};

export default inject('rootStore')(observer(AllForXHead));
